import $ from 'jquery'
// import modules here
import Example from './modules/example.js'
import hljs from 'highlight.js/lib/core'
import java from 'highlight.js/lib/languages/java'
import shell from 'highlight.js/lib/languages/shell'
import bash from 'highlight.js/lib/languages/bash'
import properties from 'highlight.js/lib/languages/properties'
import ps from 'highlight.js/lib/languages/powershell'

$(() => {
  // init modules here
  Example.init()

  hljs.registerLanguage('java', java)
  hljs.registerLanguage('shell', shell)
  hljs.registerLanguage('bash', bash)
  hljs.registerLanguage('properties', properties)
  hljs.registerLanguage('powershell', ps)
  hljs.highlightAll()

  $(".c-site-nav__topmenu-link").on('click', function(){
    $(".c-site-nav__list-item").not( $(this).parents(".c-site-nav__list-item")).removeClass("c-site-nav__list-item_active")
    $(this).parents(".c-site-nav__list-item").toggleClass("c-site-nav__list-item_active")

  })
})
